<template>
  <div
    class="app-icon"
    :style="{ width: size + 'px', height: size + 'px' }"
    v-html="svgContent"
    v-on="$listeners"
  ></div>
</template>

<script>
import svgCache from '@/utils/svgCache'

export default {
  name: 'AppIcon',
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 24
    },
    colorMap: {
      type: Object,
      default: null
    },
    preserveColors: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      svgContent: ''
    }
  },
  watch: {
    src: {
      immediate: true,
      handler: 'loadSvg'
    },
    colorMap: {
      handler: 'loadSvg'
    },
    preserveColors: {
      handler: 'loadSvg'
    }
  },
  methods: {
    async loadSvg() {
      try {
        // Use global cache manager - this ensures only 1 fetch per unique SVG
        this.svgContent = await svgCache.get(
          this.src,
          this.colorMap,
          this.preserveColors,
          this.$vuetify
        )
      } catch (error) {
        console.error('Error loading SVG:', error, 'src:', this.src)
        this.svgContent = `<svg width="${this.size}" height="${this.size}" viewBox="0 0 24 24"><text x="50%" y="50%" text-anchor="middle" dy=".3em">?</text></svg>`
      }
    }
  }
}
</script>

<style>
.app-icon {
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
  color: inherit;
}

.app-icon svg {
  display: block;
  width: 100%;
  height: 100%;
  color: inherit;
}

/* Fallback color only when there is no color inherited */
.v-btn:not([class*="white"]) .app-icon,
.app-icon:not(.v-btn *) {
  color: var(--v-primary-base);
}
</style>
